var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeoConnectLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 29.568602,30.933617 0.299409,19.183725 c 0.178284,11.422981 6.018399,20.318907 20.385173,20.318907 14.366778,0 19.785574,-8.852761 19.778475,-19.962012 L 70.01904,30.694479",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 9.6467,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.6413763,48.96251 8.9407854,29.778785 C 9.119069,18.355807 14.959184,9.4598779 29.325958,9.4598779 c 14.366775,0 19.785571,8.8527631 19.778472,19.9620121 l -0.01262,19.779758",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 9.6467,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeoConnectLogo);
export default __webpack_public_path__ + "static/media/neo-connect_logo.a1fb5e40f5a7ad943911e4e49e402f73.svg";
export { ForwardRef as ReactComponent };